import React from 'react';
import PropTypes from 'prop-types';

// Components
import ListCard from '../../../components/ListCard';
import HubStatusWidget from '../../../components/HubStatusWidget';

// Icons
import Hallway from '../../../images/customIcons/Hallway.png';
import Room from '../../../images/customIcons/Room.png';
import Door from '../../../images/customIcons/Door.png';

// Constants
import { T, FONT_MONO } from '../../../constants/tokens';

function getIcon(hubType) {
  switch (hubType){
    case 'Hallway':
      return Hallway;
    case 'Room':
      return Room;
    case 'Door':
      return Door;
    default:
      return;
  }
}

export default function HubListCard({ hub, onClick, selectedCardObject }) {
  const statusColor = hub?.getRoom()?.getAlertStatus()?.getColor()?.main;

  return (
    <ListCard
      statusColor={statusColor}
      onClick={onClick}
      isSelected={selectedCardObject === hub}
      selectedColor={statusColor}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <img
          src={getIcon(hub.getHubType())}
          alt=''
          style={{ width: 28, height: 28, flex: 'none', objectFit: 'contain' }}
        />

        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '20px',
              color: T.ink,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {hub.getSerialNumber()}
          </div>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: 12,
              fontWeight: 500,
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: T.muted
            }}
          >
            {hub.getHubType()}
            {hub.getRoom()?.getIdentifier() && ' · ' + hub.getRoom().getIdentifier()}
          </div>
        </div>

        <div style={{ flex: 'none' }}>
          <HubStatusWidget hub={hub} />
        </div>
      </div>
    </ListCard>
  );
}

HubListCard.propTypes = {
  hub: PropTypes.object,
  onClick: PropTypes.func,
  selectedCardObject: PropTypes.object
};
